import { Component, OnInit, ViewChild } from '@angular/core'
import { MatTableDataSource } from '@angular/material/table'
import { MatSort } from '@angular/material/sort'
import { MatPaginator } from '@angular/material/paginator'
import { StatusInscricao } from 'src/app/models/status-inscricao'
import { PropgService } from 'src/app/services/propg-service'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { DataService } from 'src/app/services/data-service'
import { UnespConfirmDialogModel, UnespConfirmDialogComponent } from '@unesp/shared'
import { MatDialog as MatDialog } from '@angular/material/dialog'
import { UnespCoreMessageService } from '@unesp/core'
import {
  DisciplinaData,
  PropgEditarResponsaveisInscricaoComponent,
} from './propg-editar-responsaveis-inscricao/propg-editar-responsaveis-inscricao.component'

@Component({
  selector: 'app-propg-status-inscricao',
  templateUrl: './propg-status-inscricao.component.html',
  styleUrls: ['./propg-status-inscricao.component.css'],
  standalone: false
})
export class PropgStatusInscricaoComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator
  @ViewChild(MatSort) sort!: MatSort

  colunasGrid: string[] = ['detalhes', 'resumo', 'action']
  dataSource: MatTableDataSource<StatusInscricao> = new MatTableDataSource()

  anos: number[] = []
  anoSelecionado: number = 0
  form = new FormGroup({
    cpf: new FormControl('', Validators.required),
  })

  constructor(
    private propgService: PropgService,
    private dataService: DataService,
    private dialog: MatDialog,
    private unespCoreMessageService: UnespCoreMessageService
  ) {}

  ngOnInit(): void {
    this.anos = this.dataService.listYearsSince2022()
    this.anoSelecionado = this.dataService.getCachedYearSince2022()
  }

  getData(): void {
    let cpf = this.form.controls['cpf'].getRawValue()
    this.dataService.setCachedYearSince2022(this.anoSelecionado)
    if (cpf && cpf.length === 11) {
      this.propgService.statusInscricao(cpf, this.anoSelecionado).subscribe(data => {
        this.dataSource = new MatTableDataSource(data)
        this.dataSource.sort = this.sort
        this.dataSource.paginator = this.paginator
      })
    }
  }

  filtrar() {
    if (this.form.controls['cpf'].getRawValue()!.length === 11) {
      this.getData()
    }
  }

  reenviarAlunoPaades(id: number): void {
    const confirmDialog = new UnespConfirmDialogModel(
      'Atenção',
      `Deseja realmente reenviar a inscrição #${id} para o SISGRAD?`
    )
    const dialogRef = this.dialog.open(UnespConfirmDialogComponent, {
      data: confirmDialog,
    })
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.propgService.reenviarAlunoPaades(id).subscribe(data => {
          if (data.status === 'ok') {
            this.unespCoreMessageService.showMessageSuccess(`Inscrição #${id} reenviada com sucesso`)
          } else {
            this.unespCoreMessageService.showMessageError(data.message)
          }
        })
      }
    })
  }

  liberarCorrecaoCargaHoraria(id: number): void {
    const confirmDialog = new UnespConfirmDialogModel(
      'Atenção',
      `Deseja realmente liberar a correção da carga horária na inscrição #${id}?`
    )
    const dialogRef = this.dialog.open(UnespConfirmDialogComponent, {
      data: confirmDialog,
    })
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.propgService.liberarCorrecaoCargaHoraria(id).subscribe(data => {
          if (data) {
            this.unespCoreMessageService.showMessageSuccess(`Correção da carga horária na inscrição #${id} liberada`)
            let inscricoes = this.dataSource.data
            let inscricao = inscricoes.find(i => i.id === id)
            if (inscricao) inscricao.cargaHorarioEfetivaLancada = 'PENDENTE'
            this.dataSource.data = inscricoes
          }
        })
      }
    })
  }

  liberarCorrecaoRelatorioAtividades(id: number): void {
    const confirmDialog = new UnespConfirmDialogModel(
      'Atenção',
      `Deseja realmente liberar a correção do relatório de atividades da inscrição #${id}?`
    )
    const dialogRef = this.dialog.open(UnespConfirmDialogComponent, {
      data: confirmDialog,
    })
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.propgService.liberarCorrecaoRelatorioAtividades(id).subscribe(data => {
          if (data) {
            this.unespCoreMessageService.showMessageSuccess(`Correção do relatório de atividades da inscrição #${id} liberada`)
            let inscricoes = this.dataSource.data
            let inscricao = inscricoes.find(i => i.id === id)
            if (inscricao) {
              inscricao.relatorioAprovadoDocenteResponsavel = 'PENDENTE'
              inscricao.relatorioHomologadoChefeDepartamento = 'PENDENTE'
            }
            this.dataSource.data = inscricoes
          }
        })
      }
    })
  }

  scrollTo(element: any): void {
    (document.getElementById(element) as HTMLElement).scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    })
  }

  editarResponsaveis(inscricao: StatusInscricao) {
    const data: DisciplinaData = {
      id: inscricao.id,
      nome: inscricao.nome,
      responsaveis: inscricao.docentesResponsaveis,
    }

    this.dialog
      .open(PropgEditarResponsaveisInscricaoComponent, { data, width: '80%' })
      .afterClosed()
      .subscribe(() => {
        this.filtrar()
      })
  }

  excluir(id: number): void {
    const confirmDialog = new UnespConfirmDialogModel(
      'Atenção',
      `Deseja realmente excluir a inscrição #${id}?`
    )
    const dialogRef = this.dialog.open(UnespConfirmDialogComponent, {
      data: confirmDialog,
    })
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.propgService.excluir(id).subscribe(data => {
          if (data) {
            this.unespCoreMessageService.showMessageSuccess(`Inscrição #${id} excluída com sucesso`)
            this.filtrar()
          }
        })
      }
    })
  }

  excluirCertificados(id: number): void {
    const confirmDialog = new UnespConfirmDialogModel(
      'Atenção',
      `Deseja realmente excluir o(s) certificado(s) da inscrição #${id}?`
    )
    const dialogRef = this.dialog.open(UnespConfirmDialogComponent, {
      data: confirmDialog,
    })
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.propgService.excluirCertificados(id).subscribe(data => {
          if (data) {
            this.unespCoreMessageService.showMessageSuccess(`Certificado(s) da inscrição #${id} excluído(s) com sucesso`)
            this.filtrar()
          }
        })
      }
    })
  }
}
